import React from 'react';

const Logo = ({ 
  variant = 'primary', 
  size = 'medium', 
  className = '',
  onClick,
  responsive = true
}) => {
  const getLogoSrc = () => {
    // Use responsive logos by default
    if (responsive) {
      return {
        full: '/logos/logo-full-with-icon.svg',
        compact: '/logos/logo-compact.svg'
      };
    }
    
    // Fallback to specific variants
    switch (variant) {
      case 'white':
        return '/logos/logo-white.png';
      case 'small':
        return '/logos/logo-small.png';
      case 'horizontal':
        return '/logos/logo-horizontal.png';
      default:
        return '/logos/logo-primary.png';
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'h-6 w-auto';
      case 'large':
        return 'h-12 w-auto';
      case 'xl':
        return 'h-16 w-auto';
      default:
        return 'h-8 w-auto';
    }
  };

  const logoSrc = getLogoSrc();

  if (responsive && typeof logoSrc === 'object') {
    return (
      <div className={`${getSizeClasses()} ${className}`} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        {/* Full logo for larger screens */}
        <img
          src={logoSrc.full}
          alt="EnglishPT Logo"
          className="hidden md:block w-full h-full"
          onError={(e) => {
            console.error('Failed to load full logo:', logoSrc.full);
            e.target.style.display = 'none';
          }}
        />
        {/* Compact logo for smaller screens */}
        <img
          src={logoSrc.compact}
          alt="EnglishPT Logo"
          className="md:hidden w-full h-full"
          onError={(e) => {
            console.error('Failed to load compact logo:', logoSrc.compact);
            e.target.style.display = 'none';
          }}
        />
      </div>
    );
  }

  return (
    <img
      src={logoSrc}
      alt="EnglishPT Logo"
      className={`${getSizeClasses()} ${className}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      onError={(e) => {
        console.error('Failed to load logo:', logoSrc);
        e.target.style.display = 'none';
      }}
    />
  );
};

export default Logo; 